export {default as data} from './index.json';
import {Component} from 'intact';
import template from './index.vdt';
import './index.styl'; 

import {bind} from 'kpc';

interface Props {
    expandedKeys?: string[]
    selectedKey?: string
    collapse: boolean
    data: any[]
}

export default class Demo extends Component<Props> {
    static template = template;

    static defaults() {
        return {
            expandedKeys: [],
            selectedKey: '3-1',
            collapse: false,
            data: Array.apply(null, {length: 100} as unknown[]),
        };
    }

    @bind
    toggle() {
        this.set('collapse', !this.get('collapse'));
    }
}